
import axios from "axios";
import store from "@/store/store-controller/store.js";

const platform = "taiyou2"


function getUrl(endPoint, params) {
    let url = endPoint + "?"
    for (let key in params) {
        if (params[key] != "" && params[key] != undefined) {
            if (url.slice(url.length - 1) == "?") {
                url += key + "=" + params[key];
            }
            else {
                url += "&" + key + "=" + params[key];
            }
        }
    }
    return url;
}


/**
 * 解析從後端取得後台設定的josn，最後存於store
 * @param {*} json 
 */
function parseBackendSetting(json) {
    // 解析backend setting的json
    if (json.status != undefined && json.status == "success") {
        let homeCarouselBanner = []; // Home.vue所需
        let topBackgroundImgUrl = ""; // 背景圖片
        for (let i = 0; i < json.results.length; i++) {
            const tmpJson = json.results[i];

            // Home頁的carousel banner
            if (tmpJson.belongCode == process.env.VUE_APP_BACKEND_SETTING_BELONG_CODE_HOME
                && tmpJson.bannerCategory == process.env.VUE_APP_BACKEND_SETTING_BANNER_CATEGORY_CAROUSELBANNER) {
                homeCarouselBanner = tmpJson.result;
            }

            // 適用於所有頁面上方背景圖
            if (tmpJson.belongCode == process.env.VUE_APP_BACKEND_SETTING_BELONG_CODE_ALLPAGES
                && tmpJson.bannerCategory == process.env.VUE_APP_BACKEND_SETTING_BANNER_CATEGORY_TOPBACKGROUNDIMGURL) {
                if (tmpJson.result.length >= 1 && tmpJson.result[0].fileType == "image") {
                    topBackgroundImgUrl = tmpJson.result[0].imageFile
                }
            }

            // 適用於Deposit頁面上方背景圖
            if (tmpJson.belongCode == process.env.VUE_APP_BACKEND_SETTING_BELONG_CODE_DEPOSIT
                && tmpJson.bannerCategory == process.env.VUE_APP_BACKEND_SETTING_BANNER_CATEGORY_TOPBACKGROUNDIMGURL) {
                if (tmpJson.result.length >= 1 && tmpJson.result[0].fileType == "image") {
                    store.dispatch(
                        "storeBackendSetting/actionSetDepositTopBackgroundImgUrl",
                        tmpJson.result[0].imageFile
                    );
                    
                }
            }
        }
        store.dispatch(
            "storeBackendSetting/actionSetCarouselBannerArray",
            homeCarouselBanner
        );
        store.dispatch(
            "storeBackendSetting/actionSetTopBackgroundImgUrl",
            topBackgroundImgUrl
        );
    }
}


/**
 * 清空所有從後台取得並記錄在store的設定
 */
async function cleanAllBackendSetting() {
    return new Promise(function (resolve) {
        store.dispatch("storeBackendSetting/actionSetCarouselBannerArray", []);
        store.dispatch("storeBackendSetting/actionSetTopBackgroundImgUrl", "");
        store.dispatch("storeBackendSetting/actionSetDepositTopBackgroundImgUrl", "");
        resolve();
    })
}



/**
 * 向後端取後台的設定，成功回傳true，失敗回傳false
 * @param {*} languageCode 
 */
async function getBackendSetting(languageCode = process.env.VUE_APP_I18N_LOCALE) {
    const endPoint = process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getBanner2ItemInfoAction.shtml";
    // en語系不分地區(en-US, en-GN...etc)，一律以en向後端取資料
    if (/^en/.test(languageCode)) {
        languageCode = "en";
    }
    
    const params = {
        "banner.platform": platform,
        "banner.languageCode": languageCode,
    }
    const url = getUrl(endPoint, params);

    const response = await axios({
        method: "get",
        url: url,
        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
    }).catch(function () {
        console.log('Connection failed!');
    });


    if (response != undefined && response.status == 200 && response.data != undefined) { // ajax成功
        parseBackendSetting(response.data);
    }
    else {
        return false;
    }

    return true
}


/**
 * 首頁的carousel banner設定
 * @param {} languageCode 
 */
async function getCarouselBanner(languageCode = process.env.VUE_APP_I18N_LOCALE) {
    let carouselBannerArray = [];

    if (store.getters["storeBackendSetting/getCarouselBannerArray"].length > 0) {
        carouselBannerArray = store.getters["storeBackendSetting/getCarouselBannerArray"];
    }
    else {
        //  依照語系向後端取資料
        const response = await getBackendSetting(languageCode);
        if (response) { // ajax成功
            if (store.getters["storeBackendSetting/getCarouselBannerArray"].length > 0) {
                carouselBannerArray = store.getters["storeBackendSetting/getCarouselBannerArray"];
            }
        }
    }

    return carouselBannerArray;
}


/**
 * 上方背景圖
 * @param {} languageCode 
 */
async function getTopBackgroundImgUrl(languageCode = process.env.VUE_APP_I18N_LOCALE, storName = "storeBackendSetting/getTopBackgroundImgUrl") {
    let imageUrl = "";
    const defaultStorName = "storeBackendSetting/getTopBackgroundImgUrl";

    if (store.getters[storName]) {
        imageUrl = store.getters[storName];
    }
    else {
        //  依照語系向後端取資料
        const response = await getBackendSetting(languageCode);
        if (response) { // ajax成功
            if (store.getters[storName]) { // 根據指定的store讀取
                imageUrl = store.getters[storName]
            }
            else if (store.getters[defaultStorName]) { // 讀取預設store
                imageUrl = store.getters[defaultStorName]
            }
        }
    }

    return imageUrl;
}


export { cleanAllBackendSetting, getCarouselBanner, getTopBackgroundImgUrl }